/**
 * Homepage script
 *
 * @author HammersportMarketing
 */
import "../../sass/homepage.scss";
// import Swiper JS
import Swiper from "swiper";
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination } from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination]);

new Swiper(".home-banner-slider", {
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 50,
  // Optional parameters
  dynamicBullets: true,
  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },
  observeParents: true,
  observer: true,
});

new Swiper(".benefits-slider", {
  slidesPerView: "auto",
  centeredSlides: true,
  // Optional parameters
  dynamicBullets: true,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    disabledClass: "swipe-control-disabled",
    nextEl: ".swipe-next",
    prevEl: ".swipe-prev",
  },
  observeParents: true,
  observer: true,
  freeMode: true,
});

new Swiper(".racetrack-slider", {
  slidesPerView: "auto",
  centeredSlides: true,
  // Optional parameters
  dynamicBullets: true,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    disabledClass: "swipe-control-disabled",
    nextEl: ".swipe-next",
    prevEl: ".swipe-prev",
  },
  observeParents: true,
  observer: true,
  freeMode: true,
});

// Buyers journey

$(".buyers-btn").on("click", function () {
  // Button handle for desktop version

  if (!$(this).hasClass("active")) {
    // Treat the sibling first
    $(this).parent().find(".btn").addClass("d-none");
    $(this).parent().find(".buyers-btn.active").removeClass("active");
    $(this).addClass("active");
  }
  // Desktop handler
  if ($(window).width() > 768) {
    if ($(".buyers-btn.active").hasClass("what-most-do")) {
      $(".buyers-journey-wrapper.what-most-do").removeClass("d-none");
      $(".buyers-journey-wrapper.what-we-do").addClass("d-none");
      $(".active-spacer").css("background-color", "#FB9B4E");
    } else {
      $(this).find(".btn").removeClass("d-none");
      $(".buyers-journey-wrapper.what-we-do").removeClass("d-none");
      $(".buyers-journey-wrapper.what-most-do").addClass("d-none");
      $(".active-spacer").css("background-color", "#465B7F");
    }
    // Mobile
  } else {
    if ($(".buyers-btn.active").hasClass("what-most-do")) {
      $(".slider-wrapper.what-most-do").removeClass("d-none");
      $(".slider-wrapper.what-we-do").addClass("d-none");
      $(".active-spacer").css("background-color", "#FB9B4E");
    } else {
      $(this).find(".btn").addClass("d-none");
      $(".slider-wrapper.what-we-do").removeClass("d-none");
      $(".slider-wrapper.what-most-do").addClass("d-none");
      $(".active-spacer").css("background-color", "#465B7F");
    }
  }
});

function buyersJourneySectionResizeHandler() {
  $(".active-spacer").css(
    "background-color",
    $(".buyers-btn.active").css("background-color")
  );
  // Set What most do section active by default
  $(".buyers-btn.what-most-do").addClass("active");
  $(".buyers-btn.what-we-do").removeClass("active");
  // Desktop handler
  if ($(window).width() > 768) {
    // Hide mobile layout
    $(".slider-wrapper.what-most-do").removeClass("d-none");
    $(".slider-wrapper.what-we-do").removeClass("d-none");
    // Make desktop layout visible
    $(".buyers-btn.active").hasClass("what-most-do")
      ? $(".buyers-journey-wrapper.what-most-do").removeClass("d-none")
      : $(".buyers-journey-wrapper.what-we-do").removeClass("d-none");
    // Mobile handler
  } else {
    // hide desktop layout
    $(".buyers-journey-wrapper.what-most-do").addClass("d-none");
    $(".buyers-journey-wrapper.what-we-do").addClass("d-none");
    $(".buyers-btn.what-we-do").find(".btn").addClass("d-none");
    $(".slider-wrapper.what-we-do").addClass("d-none");
    // Make mobile layout visible
    $(".buyers-btn.active").hasClass("what-most-do")
      ? $(".slider-wrapper.what-most-do").removeClass("d-none")
      : $(".slider-wrapper.what-we-do").removeClass("d-none");
  }
}

$(function () {
  buyersJourneySectionResizeHandler();
});

$(window).on("resize", function () {
  buyersJourneySectionResizeHandler();
});

$(window).on("scroll", function () {
  var bg_video = $("#why-we-do-this-section").find(".bg-video");
  if (
    $("#why-we-do-this-section").is(":in-viewport(200)") &&
    !bg_video.hasClass("video-thriggered")
  ) {
    bg_video.get(0).play();
    bg_video.addClass("video-thriggered");
    // Add fadeIn classes
    $("#why-we-do-this-section")
      .find(".title-animated")
      .removeClass("opacity-0");
    $("#why-we-do-this-section")
      .find("h2 span.text-white")
      .addClass(
        "animate__animated animate__fadeIn animate__slower animate__delay-3s"
      );
    $("#why-we-do-this-section")
      .find("h2 span.text-blue")
      .addClass(
        "animate__animated animate__fadeIn animate__slower animate__delay-5s"
      );
  }
});
